import { useTranslation } from 'react-i18next'

/** Shown while a screen's code loads (lazy routes). */
export function PageLoading() {
  const { t } = useTranslation()
  return (
    <div className="page-loading" role="status">
      <span className="spinner" aria-hidden="true" />
      <span>{t('app.loading')}</span>
    </div>
  )
}
